export default defineNuxtRouteMiddleware(({ query }) => {
  const { isAutoPromoCodeEnabled } = useAppConfig().pages.cart.coupon
  if (isClient() && isAutoPromoCodeEnabled && isString(query.autoPromoCode)) {
    useSessionStorage('autoPromoCode', '').value = query.autoPromoCode
  }
})
